


















































import Vue from 'vue';
import { mapGetters } from 'vuex';
import {
  DECREMENT_EDIT_STEP,
  INCREMENT_EDIT_STEP,
  IRRADIATED_RECEPTOR_ATOMS_REQUEST,
  IS_LOADING,
} from './RedMatCalculationModule';
import ReceptorIrradiatedAtomFilterTypes from './ReceptorIrradiatedAtomsFilterTypes';
import SetReceptorIrradiatedAtomsCommand from './SetReceptorIrradiatedAtomsCommand';
import ReceptorAtomDTO from './ReceptorAtomDTO';

export default Vue.extend({
  name: 'SetIrradiatedAtoms',
  data() {
    return {
      currentFilter: ReceptorIrradiatedAtomFilterTypes.Methyl,
      receptorAtoms: [] as ReceptorAtomDTO[],
      shiftX: null as File | null,
    };
  },
  computed: {
    ...mapGetters({
      isLoading: IS_LOADING,
    }),
    filterTypes() {
      return ReceptorIrradiatedAtomFilterTypes;
    },
    radioIsValid() {
      if (this.currentFilter === this.filterTypes.ShiftX) {
        return !!this.shiftX;
      }

      return true;
    },
  },
  methods: {
    onClickPrevious() {
      this.$store.dispatch(DECREMENT_EDIT_STEP);
    },
    onClickNext() {
      const command: SetReceptorIrradiatedAtomsCommand = {
        receptorAtoms: this.receptorAtoms,
        filter: this.currentFilter,
        shiftX: this.shiftX,
      };

      this.$store.dispatch(IRRADIATED_RECEPTOR_ATOMS_REQUEST, command)
        .then(() => {
          this.$store.dispatch(INCREMENT_EDIT_STEP);
        })
        .catch(() => {
          // do nothing
        });
    },
    onChangeAtomSelectorOption(option: string) {
      if (option === ReceptorIrradiatedAtomFilterTypes.ShiftX) {
        const shiftx = this.$refs.shiftx as HTMLElement;
        shiftx.click();
      }
    },
    onFileInputChangeShiftX(e) {
      const { files } = e.target;
      if (files && files.length > 0) {
        [this.shiftX] = files;
      }
    },
  },
  created() {
    // deep clone ligand atoms from the store
    this.receptorAtoms = JSON.parse(JSON.stringify(
      this.$store.state.redMatCalculation.receptorAtoms,
    ));
  },
});
